<div class="inputGrid w-full">
    <app-input-fulltext
        class="w-full"
        [form]="form"
        [options]="store.carePlans()"
        (selectedOptionChange)="selectedCarePlanChange($event)"
    ></app-input-fulltext>
    <app-button
        [disabled]="!store.isAllowed('carePlan.update')() || store.isTerminated()"
        (clickEvent)="save()"
        [loading]="store.loadingAny()"
        icon="pi-save"
        label="folder.carePlan.action.save"
        class="white-space-nowrap"
    ></app-button>
    <app-button
        icon="pi-print"
        severity="secondary"
        label="folder.carePlan.action.print"
        class="white-space-nowrap"
        (clickEvent)="print()"
    ></app-button>
    <div class="flex-column gap left-container">
        <app-service-pattern-wysiwyg
            #wysiwygData
            [form]="form"
            [personId]="store.folder()?.person.id || 0"
            [serviceId]="store.serviceId()"
            [usage]="servicePatternUsageEnum.CARE_PLAN"
            editorKey="FolderCarePlanData"
            id="selectedCarePlanData"
            [height]="undefined"
            (addedPattern)="formAddText(form, 'selectedCarePlanData', $event.content)"
            [patternGroups]="wysiwygPatterGroupsMedicalFolder"
        ></app-service-pattern-wysiwyg>
        <app-input-wysiwyg
            #wysiwygSymptoms
            placeholder="folder.carePlan.fields.symptoms"
            [form]="form"
            editorKey="FolderCarePlanSymptoms"
            id="selectedCarePlanSymptoms"
            [autocompleteOrganization]="true"
            [height]="undefined"
            [patternGroups]="wysiwygPatterGroupsMedicalFolder"
        ></app-input-wysiwyg>
    </div>

    <p-listbox class="fr-2"
        [options]="store.carePlans()"
        [(ngModel)]="selectedCarePlan"
        (onChange)="listChange($event)"
        [filter]="true"
        [filterPlaceHolder]="'folder.carePlan.action.history' | translate"
        optionLabel="createdAt"
        dataKey="index"
        styleClass="h-full"
        scrollHeight="calc(100vh - 20rem)"
        [emptyMessage]="'inputs.noResultsFound' | translate"
    >
        <ng-template pTemplate="item" let-item>
            <div (contextmenu)="rightClick(contextMenu, $event, item)" class="w-full">
                <div class="flex-column gap-x-small">
                    <div>{{ item.createdAt }}</div>
                    @if (item.user) {
                        <app-user-chip [user]="item.user"></app-user-chip>
                    }
                </div>
            </div>
        </ng-template>
    </p-listbox>
</div>

<p-contextMenu #contextMenu [model]="contextMenuItems"></p-contextMenu>
